import { getFile, getUploadProgress } from './fileUploadGetters';
export const uploadedBytes = fileUpload => {
  const file = getFile(fileUpload);
  const progress = getUploadProgress(fileUpload);
  if (!file || !progress) {
    return 0;
  }
  return progress / 100 * file.size;
};